import { Dispatch } from 'redux';
import { getUserInfos } from "@/api";
import { getCodeAll, receiveUnitChargeItem } from '@/api/charge';
import { getAssetTypeCode } from "@/api/franchisee";
export const USER = 'COMMON/USER';
export const GLOADING = 'COMMON/LOADING';
export const EXPORTLOADING = 'COMMON/EXPORTLOADING';
export const MENUS = 'COMMON/MENUS';
export const PAGINATION = 'COMMON/PAGINATION';
export const CRUMBS = 'COMMON/CRUMBS';
export const POST = 'COMMON/POST';
export const AUTHORITY = 'COMMON/AUTHORITY';
export const ALLDICT = 'COMMON/ALLDICT';
export const USERACTINOS = 'COMMON/USERACTINOS';
export const ROLES = 'COMMON/ROLES';
export const ROLESNAME = 'COMMON/ROLESNAME';
export const RECEIVEUNIT = 'COMMON/RECEIVEUNIT';
export const MASTERMARKET = 'COMMON/MASTERMARKET';
export const USERNAME = 'COMMON/USERNAME';
export const PSID = 'COMMON/PSID';
export const TRADER = 'COMMON/TRADER';// 加盟商 or 支持经理
export const ACCOUNT = 'COMMON/ACCOUNT';// 传参使用
export const RECRUIT = 'COMMON/RECRUIT';// 招募使用
export const AIBRIDGE = 'COMMON/AIBRIDGE';// AI 助手 bridge ACTION

const actions = {

  setLoading: (data: object) => ({
    type: GLOADING,
    payload: data
  }),

  setExportLoading: (data: object) => ({
    type: EXPORTLOADING,
    payload: data
  }),

  setCrumbs: (data: object) => (dispatch: Dispatch) => {
    // 可以异步操作后再 dispatch， 源码是对象就dispatch对象，是函数就执行函数并传入dispatch，函数可以一直调用插件函数，最后一个函数dispatch
    dispatch({
      type: CRUMBS,
      payload: data
    })
  },

  setUsers: (data: object) => {
    return {
      type: USER,
      payload: data
    };
  },

  setMenus: (list: any[]) => {
    return {
      type: MENUS,
      payload: { menus: list }
    };
  },

  setPagination: (data: object) => {
    return {
      type: PAGINATION,
      payload: data
    };
  },

  setPost: (post: string) => ({
    type: POST,
    payload: post
  }),

  setAuthority: (data: string) => ({
    type: AUTHORITY,
    payload: data
  }),

  setTrader: (data: string) => ({
    type: TRADER,
    payload: data
  }),

  setAllDict: () => (dispatch: Dispatch) => {
    getCodeAll().then((data: any) => {
      if (data.code && data.code !== 0) {
        // tslint:disable-next-line:no-parameter-reassignment
        data = []
      }
      dispatch({
        type: ALLDICT,
        payload: data
      })
    })
  },

  setUserInfos: () => (dispatch: Dispatch) => {
    getUserInfos().then((data: any) => {
      // tslint:disable-next-line:max-line-length
      // const data = { "account": "admin1", "psId": "'", "cnName": "admin1", "enName": "admin1", "mobile": "18888888888", "email": "222@qq.com", "roles": [{ "id": "11", "name": "System Supervisor", "enumNo": "32" }, { "id": "34", "name": "财务收费主档确认岗", "enumNo": "102" }, { "id": "33", "name": "财务收费主档维护岗", "enumNo": "101" }, { "id": "12", "name": "支持经理", "enumNo": "26" }, { "id": "35", "name": "加盟部收费对口人", "enumNo": "104" }, { "id": "40", "name": "线下到账查询财务", "enumNo": "35" }, { "id": "38", "name": "财务上传百胜付款表岗", "enumNo": "108" }, { "id": "36", "name": "财务收费检查岗", "enumNo": "106" }, { "id": "37", "name": "财务上传手工账单岗", "enumNo": "107" }, { "id": "14", "name": "Function Leader", "enumNo": "28" }, { "id": "19", "name": "财务", "enumNo": "31" }, { "id": "39", "name": "财务上传发票信息岗", "enumNo": "109" }, { "id": "13", "name": "市场MM", "enumNo": "27" }], "actions": [{ "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010101", "actionCnName": "查询", "actionEnName": "change_item_search" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010102", "actionCnName": "新建", "actionEnName": "change_item_add" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010103", "actionCnName": "导出", "actionEnName": "change_item_export" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010104", "actionCnName": "编辑", "actionEnName": "change_item_edit" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010105", "actionCnName": "查看", "actionEnName": "change_item_view" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010106", "actionCnName": "复制新增", "actionEnName": "change_item_copy" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010121", "actionCnName": "保存", "actionEnName": "change_item_save" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010122", "actionCnName": "提交", "actionEnName": "change_item_submit" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010123", "actionCnName": "确认", "actionEnName": "change_item_confirm" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010124", "actionCnName": "退回", "actionEnName": "change_item_backoff" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010125", "actionCnName": "删除", "actionEnName": "change_item_delete" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010126", "actionCnName": "返回", "actionEnName": "change_item_return" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010127", "actionCnName": "复制新增-账务字段", "actionEnName": "change_item_cpoy_finance" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010128", "actionCnName": "删除-账务字段", "actionEnName": "change_item_delete_finance" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "2101010201", "actionCnName": "新建", "actionEnName": "change_mode_add" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "2101010202", "actionCnName": "编辑", "actionEnName": "change_mode_edit" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "2101010203", "actionCnName": "查看", "actionEnName": "change_mode_view" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "21010102021", "actionCnName": "保存", "actionEnName": "change_mode_save" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "21010102022", "actionCnName": "提交", "actionEnName": "change_mode_submit" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "21010102024", "actionCnName": "删除", "actionEnName": "change_mode_delete" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "21010102026", "actionCnName": "新增行", "actionEnName": "change_mode_add_row" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "2101010301", "actionCnName": "新建正常收费标准", "actionEnName": "change_standard_add_normal" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "2101010302", "actionCnName": "新建减免收费标准", "actionEnName": "change_standard_add_reduce" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "2101010303", "actionCnName": "编辑", "actionEnName": "change_standard_edit" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "2101010304", "actionCnName": "查看", "actionEnName": "change_standard_view" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "2101010305", "actionCnName": "复制新建", "actionEnName": "change_standard_copy" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103021", "actionCnName": "保存", "actionEnName": "change_standard_save" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103022", "actionCnName": "提交", "actionEnName": "change_standard_submit" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103024", "actionCnName": "删除", "actionEnName": "change_standard_delete" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103027", "actionCnName": "新增行", "actionEnName": "change_standard_add_row" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010401", "actionCnName": "编辑", "actionEnName": "change_item_business_edit" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010402", "actionCnName": "查看", "actionEnName": "change_item_business_view" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010421", "actionCnName": "导入清单", "actionEnName": "change_item_business_export" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010422", "actionCnName": "新增", "actionEnName": "change_item_business_add" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010423", "actionCnName": "保存", "actionEnName": "change_item_business_save" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010424", "actionCnName": "提交", "actionEnName": "change_item_business_submit" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "21010102023", "actionCnName": "确认", "actionEnName": "change_mode_confirm" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103023", "actionCnName": "确认", "actionEnName": "change_standard_confirm" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103025", "actionCnName": "退回", "actionEnName": "change_standard_backoff" }, { "functionCode": "21010104", "functionCnName": "", "functionEnName": "", "actionCode": "2101010425", "actionCnName": "确认", "actionEnName": "change_item_business_confirm" }, { "functionCode": "21010102", "functionCnName": "", "functionEnName": "", "actionCode": "21010102025", "actionCnName": "停用", "actionEnName": "change_mode_stop" }, { "functionCode": "21010101", "functionCnName": "", "functionEnName": "", "actionCode": "2101010129", "actionCnName": "停用", "actionEnName": "change_item_stop" }, { "functionCode": "21010103", "functionCnName": "", "functionEnName": "", "actionCode": "21010103026", "actionCnName": "停用", "actionEnName": "change_standard_stop" }, { "functionCode": "21010105", "functionCnName": "", "functionEnName": "", "actionCode": "2101010501", "actionCnName": "查询", "actionEnName": "change_condition_search" }, { "functionCode": "21010106", "functionCnName": "", "functionEnName": "", "actionCode": "2101010601", "actionCnName": "查询", "actionEnName": "change_item_time_search" }, { "functionCode": "21010201", "functionCnName": "", "functionEnName": "", "actionCode": "2101020101", "actionCnName": "查询", "actionEnName": "bill_manual_search" }, { "functionCode": "21010202", "functionCnName": "", "functionEnName": "", "actionCode": "2101020201", "actionCnName": "查询", "actionEnName": "bill_monthly_search" }, { "functionCode": "21010203", "functionCnName": "", "functionEnName": "", "actionCode": "2101020301", "actionCnName": "查询", "actionEnName": "bill_franchisees_search" }, { "functionCode": "21010301", "functionCnName": "", "functionEnName": "", "actionCode": "2101030101", "actionCnName": "查询", "actionEnName": "billing_upload_search" }, { "functionCode": "21020101", "functionCnName": "", "functionEnName": "", "actionCode": "2102010101", "actionCnName": "查询", "actionEnName": "income_declare_search" }, { "functionCode": "21020102", "functionCnName": "", "functionEnName": "", "actionCode": "2102010201", "actionCnName": "查询", "actionEnName": "income_history_search" }, { "functionCode": "21020103", "functionCnName": "", "functionEnName": "", "actionCode": "2102010301", "actionCnName": "查询", "actionEnName": "income_rerecord_search" }, { "functionCode": "21010401", "functionCnName": "", "functionEnName": "", "actionCode": "2101040101", "actionCnName": "查询", "actionEnName": "offstock_smmary_search" }, { "functionCode": "21020201", "functionCnName": "", "functionEnName": "", "actionCode": "2102020101", "actionCnName": "查询", "actionEnName": "franchisees_lists_search" }, { "functionCode": "21020202", "functionCnName": "", "functionEnName": "", "actionCode": "2102020201", "actionCnName": "查询", "actionEnName": "franchisees_company_search" }, { "functionCode": "21020203", "functionCnName": "", "functionEnName": "", "actionCode": "2102020301", "actionCnName": "查询", "actionEnName": "franchisees_invoiceunit_search" }, { "functionCode": "21020204", "functionCnName": "", "functionEnName": "", "actionCode": "2102020401", "actionCnName": "查询", "actionEnName": "franchisees_restaurant_search" }] }
      if (!data.code) {
        dispatch({
          type: USERNAME,
          payload: data.cnName
        })
        dispatch({
          type: PSID,
          payload: data.psId
        })
        dispatch({
          type: ACCOUNT,
          payload: data.account
        })
        if (data.actions && data.actions.length) {
          dispatch({
            type: USERACTINOS,
            payload: data.actions.reduce((a: any, b: any) => {
              a[b.actionCode] = true
              return a
            }, {})
          })
          dispatch({
            type: ROLES,
            payload: data.roles?.reduce((a: any, b: any) => {
              a[b.enumNo] = true
              return a
            }, {})
          })
          dispatch({
            type: ROLESNAME,
            payload: data.roles?.reduce((a: any, b: any) => {
              a[b.name] = true
              return a
            }, {})
          })
        }
      } else if (`${data.code}` === '904') {
        dispatch({
          type: USERNAME,
          payload: '904'
        })
      }
    })
  },

  setReceiveUnit: () => (dispatch: Dispatch) => {
    type A = { receiveUnitNo: string, receiveUnitAliasName: string, receiveUnitName: string }
    receiveUnitChargeItem().then((data: any = []) => {
      if (data.code && data.code !== 0) {
        // tslint:disable-next-line:no-parameter-reassignment
        data = []
      }
      dispatch({
        type: RECEIVEUNIT,
        payload: data.map((item: A) => ({
          code: item.receiveUnitNo,
          label: item.receiveUnitName
        }))
      })
    })
  },

  setMasterMarket: () => (dispatch: Dispatch) => {
    type A = {
      id: number,
      brandCode: string, brand: string, typeCode: string, codeDesc: string, type: string, typeDesc: string
    }
    getAssetTypeCode({ type: 'market' }).then((data: any = []) => {
      dispatch({
        type: MASTERMARKET,
        payload: data.map((item: A) => ({
          code: item.typeCode,
          label: item.codeDesc,
          filter: item.brandCode
        }))
      })
    })
  },
  setRecruitdatas: (data: any[]) => ({
    type: RECRUIT,
    payload: data
  }),

  /** 写入 AI bridge ACTION（页面监听后自行消费并 clear） */
  setAiBridgeAction: (data: { action: string; params?: Record<string, unknown>; ts?: number } | null) => ({
    type: AIBRIDGE,
    payload: data
  }),

  clearAiBridgeAction: () => ({
    type: AIBRIDGE,
    payload: null
  }),
};

export default actions;
